import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { SectionHeading } from "@/components/Brand";
import EventCard from "@/components/EventCard";
import { useAuth } from "@/context/AuthContext";

export default function ClientGalleries() {
  const { t, path } = useI18n();
  const { user } = useAuth();
  const [q, setQ] = useState("");
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const handle = setTimeout(() => {
      api
        .get("/events", { params: q ? { q } : {} })
        .then((r) => setEvents(r.data))
        .catch(() => setEvents([]))
        .finally(() => setLoading(false));
    }, 250);
    return () => clearTimeout(handle);
  }, [q]);

  return (
    <div className="mx-auto max-w-[1500px] px-4 py-14 sm:px-8 lg:px-12 lg:py-20" data-testid="client-galleries-page">
      <SectionHeading label="HR Creations" title={t("client.title")} sub={t("client.sub")} />

      <div className="mt-10 max-w-xl">
        <label htmlFor="gallery-search" className="label-mono mb-3 block">
          {t("client.search")}
        </label>
        <div className="flex items-center border border-[#C69A3B] bg-white">
          <Search size={17} className="ml-4 text-[#C69A3B]" />
          <input
            id="gallery-search"
            data-testid="gallery-search-input"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder={t("client.searchPlaceholder")}
            className="min-h-[52px] w-full bg-transparent px-4 text-base outline-none"
          />
        </div>
        {!user && (
          <p className="mt-4 text-sm text-[#5A5752]">
            {t("client.needAccess")}{" "}
            <Link to={path("login")} data-testid="client-login-link" className="text-[#8F3329] underline">
              {t("btn.login")}
            </Link>
          </p>
        )}
      </div>

      <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3 lg:gap-8" data-testid="client-galleries-grid">
        {loading && <p className="col-span-full text-sm text-[#5A5752]">{t("common.loading")}</p>}
        {!loading && events.length === 0 && <p className="text-sm text-[#5A5752]">{t("client.noResults")}</p>}
        {events.map((ev) => (
          <EventCard key={ev.id} event={ev} />
        ))}
      </div>
    </div>
  );
}
